import styled from 'styled-components'
import { Radio } from 'antd'

export const AntRadio = styled(Radio)`
  .ant-radio-checked .ant-radio-inner {
    border-color: #874e31 !important;
    background-color: #874e31 !important;
  }
`
